import { Collapsible } from '@base-ui/react/collapsible'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface CollapsibleContentProps extends PartProps<Collapsible.Panel.Props> {
  className?: string
  innerClassName?: string
}

function CollapsibleContent({ className, innerClassName, children, ...props }: CollapsibleContentProps) {
  return (
    <Collapsible.Panel
      className={twMerge(
        // `transition-[height]`, not `transition-all`: height is the only thing
        // animating here, and `all` drags every other animatable property into
        // the transition for free. Height is layout-bound and already forces a
        // reflow per frame — don't pay for anything more than that.
        'text-md relative flex h-[var(--collapsible-panel-height)] flex-col justify-start overflow-hidden transition-[height] duration-150 ease-out',
        'motion-reduce:transition-none',
        'data-[starting-style]:h-0',
        'data-[ending-style]:h-0',
        className,
      )}
      {...props}
    >
      <div className={twMerge('text-foreground mt-1 flex cursor-text flex-col gap-2', innerClassName)}>{children}</div>
    </Collapsible.Panel>
  )
}

export { CollapsibleContent }
